import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Message } from "primeng/api";
import { FileUpload, FileUploadModule } from "primeng/fileupload";
import { lastValueFrom } from "rxjs";

@Component({
  selector: "app-file-upload",
  standalone: true,
  imports: [CommonModule, TranslateModule, FileUploadModule],
  templateUrl: "./file-upload.component.html",
})
export class FileUploadComponent implements OnInit {
  @ViewChild("documentUpload") documentUpload: FileUpload | undefined;
  @Input() enableDocumentUpload = false;
  @Input() showMandatoryFileUploadMessage = false;
  @Output() fileSelected = new EventEmitter<File>();

  showFileTypeErrorMessage = false;
  showMultipleUploadErrorMessage = false;
  showFileSizeErrorMessage = false;

  fileTypeErrorMessage!: Message;
  multipleFileUploadMessage!: Message;
  fileSizeErrorMessage!: Message;
  mandatoryFileUploadMessage!: Message;

  maxFileSizeMB = 4;
  acceptedFileExtensions: string[] = ["JPG", "JPEG", "PNG", "HEIC", "TIFF", "GIF", "BMP", "PDF", "MSG"];
  constructor(private readonly translate: TranslateService) {}

  async ngOnInit() {
    const multipleFileUploadError = await lastValueFrom(
      this.translate.get("contactUsForm.fileUpload.multipleFileUploadError")
    );
    const fileTypeError = await lastValueFrom(this.translate.get("contactUsForm.fileUpload.fileTypeError"));
    const fileSizeError = await lastValueFrom(
      this.translate.get("contactUsForm.fileUpload.fileSizeError", {
        size: this.maxFileSizeMB,
        unit: "MB",
      })
    );
    const mandatoryFileUploadMessage = await lastValueFrom(
      this.translate.get("contactUsForm.fileUpload.mandatoryFileUploadMessage")
    );

    this.fileTypeErrorMessage = {
      severity: "error",
      detail: fileTypeError,
      closable: false,
    };
    this.multipleFileUploadMessage = {
      severity: "error",
      detail: multipleFileUploadError,
      closable: false,
    };
    this.fileSizeErrorMessage = {
      severity: "error",
      detail: fileSizeError,
      closable: false,
    };
    this.mandatoryFileUploadMessage = {
      severity: "info",
      detail: mandatoryFileUploadMessage,
      closable: false,
    };
  }
  onFileSelected(event: any) {
    if (event.files.length > 1) {
      this.showMultipleUploadErrorMessage = true;

      event.files = [];
      this.clearDocument();
    } else if (event.files.length === 1) {
      const file = event.files[0];
      if (file.size > this.maxFileSizeMB * 1024 * 1024) {
        this.showFileSizeErrorMessage = true;
        event.files = [];
        this.clearDocument();
      } else if (!this.acceptedFileExtensions.some(ext => file.name.toUpperCase().endsWith(ext))) {
        this.showFileTypeErrorMessage = true;
        event.files = [];
        this.clearDocument();
      } else {
        this.showFileTypeErrorMessage = false;
        this.showFileSizeErrorMessage = false;
        this.showMultipleUploadErrorMessage = false;
        this.fileSelected.emit(file);
      }
    }
  }

  clearDocument() {
    this.documentUpload?.clear();
  }
  documentUploadChooseFile() {
    this.documentUpload?.choose();
  }
}
